import type { ReactNode, FC } from 'react';

import styles from './RolesLayout.module.scss';

interface RolesLayoutProps {
  children: ReactNode;
  flexType?: 'wrap' | 'wrap-reverse';
}

const RolesLayout: FC<RolesLayoutProps> = ({ children, flexType }) => {
  return (
    <div
      className={flexType === 'wrap' ? styles.container1 : styles.container2}
    >
      {children}
    </div>
  );
};

export default RolesLayout;
